<script setup lang="ts">
import { $t } from '@/i18n';
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

function gotoPromoboxx() {
    analytics.home.promoboxx();

    window.open('https://vet.trupanion.com/trupromoboxx/');
}

function screenWidthTabletOrBelow() {
    return screen.width < 1300;
}
</script>

<template>
    <div class="promoboxx">
        <TruCard>
            <div class="flex flex-nowrap">
                <div
                    class="left flex flex-col"
                    :class="{ 'mr-21': !screenWidthTabletOrBelow }"
                >
                    <img
                        class="w-45 mb-6"
                        src="../../assets/images/promoboxx_logo.png"
                        :alt="$t('dashboard.promoboxx.altText')"
                    >

                    <div class="header desk-body-bold mb-1">
                        {{ $t('dashboard.promoboxx.header') }}
                    </div>

                    <div class="desk-body-reg mb-6">
                        {{ $t('dashboard.promoboxx.body') }}
                    </div>

                    <TruButton
                        class="fit-content"
                        secondary
                        size="xs"
                        @click="gotoPromoboxx"
                    >
                        {{ $t('dashboard.promoboxx.cta') }}
                    </TruButton>
                </div>

                <img
                    class="self-center"
                    src="../../assets/images/Promoboxx_image.png"
                    alt=""
                >
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">
@use '../../scss/typography' as *;

[data-country-code=aus] {
    .promoboxx {
        .header {
            @extend .desk-sub2-bold;
            margin-bottom: 3rem;
        }
    }
}
</style>
